import { Attributes, List, Rules, Validation } from '@singularsystems/neo-core';
import EntityIssuerInvestmentDocument from './EntityIssuerInvestmentDocument';
import EntityInvestorInvestmentDocument from './EntityInvestorInvestmentDocument';
import TemporalEntity from '../../TemporalEntity';
import { TextAlignment } from '../TextAlignment';
import BankDetail from '../../ValueObjects/BankDetail';

export default class Entity extends TemporalEntity {
    static typeName = "Entity";

    constructor() {
        super();
        this.makeObservable();
    }

    public entityId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Entity")
    public entityName: string = "";

    @Rules.StringLength(6)
    public entityShortName: string = "";

    @Rules.StringLength(50)
    public registrationNo: string = "";

    @Attributes.Display("Company")
    @Rules.StringLength(100)
    public companyName: string = "";

    @Attributes.Display("Vesting Trust?")
    public hasVestingTrust: boolean = false;

    @Rules.StringLength(512)
    public reportDirectors: string = "";

    @Rules.StringLength(100)
    public friendlyName: string = "";

    @Attributes.Display("HDI?")
    public isHDI: boolean = false;

    @Attributes.Display("Investors Complete Dividend Cycle?")
    public investorsCompleteDividendCycle: boolean = false;

    @Attributes.Integer()
    @Attributes.Display("HDI Reference Number")
    public hdiRefNo: number = 0;

    @Attributes.Nullable()
    public reportHeaderImageId: number | null = null;

    public reportHeaderText: string = "";

    public reportHeaderAlignment: TextAlignment = TextAlignment.Center;

    public reportDisclaimer: string = "";

    @Attributes.Nullable()
    public trustDeedFileId: number | null = null;

    public minimumTransactionAmount: number = 0;

    public entityIssuerInvestmentDocuments = new List(EntityIssuerInvestmentDocument);

    public entityInvestorInvestmentDocuments = new List(EntityInvestorInvestmentDocument);

    @Attributes.ChildObject(BankDetail, true)
    public bankDetails: BankDetail | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.entityName) {
            return "New entity";
        } else {
            return this.entityName;
        }
    }
}